// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `No participants yet. Be the first to enter!`
};

const de_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Noch keine Teilnehmer. Seien Sie der Erste!`
};

const es_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `¡Aún no hay participantes. ¡Sé el primero en participar!`
};

const fr_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Aucun participant pour le moment. Soyez le premier à participer !`
};

const fi_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Ei osallistujia vielä. Ole ensimmäinen!`
};

const hi_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `अभी तक कोई प्रतिभागी नहीं। पहले दर्ज करें!`
};

const ja_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `まだ参加者がいません。最初に参加してください！`
};

const nl_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Nog geen deelnemers. Wees de eerste om mee te doen!`
};

const pt_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Nenhum participante ainda. Seja o primeiro a participar!`
};

const ro_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Încă nu sunt participanți. Fii primul care să participe!`
};

const th_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `ยังไม่มีผู้เข้าร่วม เป็นคนแรกที่เข้าร่วม!`
};

const ur_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `ابھی تک کوئی شرکاء نہیں۔ شرکت کرنے والے پہلے بنیں!`
};

const zh_hant1_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `還沒有參與者。成為第一個參加的人！`
};

const da_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Ingen deltagere endnu. Vær den første til at deltage!`
};

const it_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Nessun partecipante ancora. Sii il primo a partecipare!`
};

const vn_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Chưa có người tham gia. Hãy là người đầu tiên!`
};

const ko_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `아직 참가자가 없습니다. 첫 번째로 참가해보세요!`
};

const tr_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Henüz katılımcı yok. İlk katılan sen ol!`
};

const lv_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Vēl nav dalībnieku. Esiet pirmais, kas piedalās!`
};

const ar_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `لا يوجد مشاركون بعد. كن أول من يدخل!`
};

const bs_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Još nema učesnika. Budite prvi koji će ući!`
};

const sl_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Še ni udeležencev. Bodite prvi, ki vstopi!`
};

const id_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Belum ada peserta. Jadilah yang pertama!`
};

const sv_widget_leaderboard_no_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Inga deltagare än. Var den första att delta!`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_leaderboard_no_participants = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_leaderboard_no_participants(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_leaderboard_no_participants", locale)
	if (locale === "en") return en_widget_leaderboard_no_participants(inputs)
	if (locale === "de") return de_widget_leaderboard_no_participants(inputs)
	if (locale === "es") return es_widget_leaderboard_no_participants(inputs)
	if (locale === "fr") return fr_widget_leaderboard_no_participants(inputs)
	if (locale === "fi") return fi_widget_leaderboard_no_participants(inputs)
	if (locale === "hi") return hi_widget_leaderboard_no_participants(inputs)
	if (locale === "ja") return ja_widget_leaderboard_no_participants(inputs)
	if (locale === "nl") return nl_widget_leaderboard_no_participants(inputs)
	if (locale === "pt") return pt_widget_leaderboard_no_participants(inputs)
	if (locale === "ro") return ro_widget_leaderboard_no_participants(inputs)
	if (locale === "th") return th_widget_leaderboard_no_participants(inputs)
	if (locale === "ur") return ur_widget_leaderboard_no_participants(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_leaderboard_no_participants(inputs)
	if (locale === "da") return da_widget_leaderboard_no_participants(inputs)
	if (locale === "it") return it_widget_leaderboard_no_participants(inputs)
	if (locale === "vn") return vn_widget_leaderboard_no_participants(inputs)
	if (locale === "ko") return ko_widget_leaderboard_no_participants(inputs)
	if (locale === "tr") return tr_widget_leaderboard_no_participants(inputs)
	if (locale === "lv") return lv_widget_leaderboard_no_participants(inputs)
	if (locale === "ar") return ar_widget_leaderboard_no_participants(inputs)
	if (locale === "bs") return bs_widget_leaderboard_no_participants(inputs)
	if (locale === "sl") return sl_widget_leaderboard_no_participants(inputs)
	if (locale === "id") return id_widget_leaderboard_no_participants(inputs)
	if (locale === "sv") return sv_widget_leaderboard_no_participants(inputs)
	return "widget_leaderboard_no_participants"
};